export default function UniversityWebDetailsFilter() {
  return (
    <div className="add-filter">
      <div className="filter-title  filter-title-mob">
        <h5>Filter University</h5>
        <button className="mob-nav-open">☰</button>
      </div>
      <div className="filter-body filter-body-mob custom-scroll-right pt-0">
        <div className="sticky pt-2">
          <h6>
            <strong> All Filter</strong>
          </h6>
          <button className="btn btn-sm btn-deep-orange"> Clear All</button>
        </div>
      </div>
    </div>
  );
}
